var mediaSelectors = [];

(function( $ ){

	var mediaBrowser = function() {
		
		var me = this;
		var el, $el;
		
		this.settings = {
			values: [],
			mediaType: 'all',
			mediableType: '',
			mediableId: '',
			tags: [],
			multiple: false,
			filterForm: 'form[data-rel="filter"]',
			tagsContainer: '.tags',
			tagsMain: '.tags ul.main',
			tagsSubs: '.tags ul.subs',
			tagAnimation: {
				duration: 200,
				easing: 'easeInOutQuint'
			},
			mediaContainer: '.media ul',
			detailsContainer: '.details',
			urlZone: '.urlzone',
			dropZone: '.dropzone',
			tmpl: {
				noMedia: '<li class="nomedia">Geen media gevonden</li>',
				mediaRow: '<li><a href="#" data-id="${id}">{{html thumbnail}}</a><a href="#" class="remove"><span class="fa fa-trash-o"></span></a></li>' 
			},
			lightbox: true,
			onInit: null,
			onMediaReceive: null,
			url: '/api/mediabrowser/media',
			page: 1,
			perPage: 15
		}
		
		this.init = function( options ) 
		{
			$.extend(true, me.settings, options, $(this).data());
			me.el = this;
			me.$el = $(this);
			me.hasSubTags = false;
			me.type = '';
			me.requests = [];

			if(me.settings.multiple === 'true' || me.settings.multiple == '1') me.settings.multiple = true;
			if(me.settings.multiple === 'false' || me.settings.multiple == '0') me.settings.multiple = false;
			
			me.$el.filterForm = $(me.settings.filterForm, $(this));
			me.$el.tagsContainer = $(me.settings.tagsContainer, $(this));
			me.$el.mediaContainer = $(me.settings.mediaContainer, $(this));
			me.$el.detailsContainer = $(me.settings.detailsContainer, $(this));
			me.$el.urlZone = $(me.settings.urlZone, $(this));
			me.$el.dropZone = $(me.settings.dropZone, $(this));
			me.$el.loadMore = me.$el.find('[data-toggle="load-more"]');

			// Filter
			me.$el.filterForm.find(':input').on('change', me.filterByForm);
			me.$el.filterForm.on('submit', me.filterByForm);
			$('[data-rel="multiple-select"]', me.$el.filterForm).each(function()
			{
				$(this).multipleSelect();
			});

			// Tags
			me.$el.tagsContainer.find('a').click(me.filterByType);

			// Media
			if(me.settings.lightbox)
			{
				me.$el.mediaContainer.on('click', 'a:not(.remove)', me.previewMedia);
				me.$el.mediaContainer.on('click', 'a.remove', me.unpreviewMedia);
			}
			else
			{
				me.$el.mediaContainer.on('click', 'a.remove', me.removeMedia);
			}

			me.$el.loadMore.on('click', me.loadMore);

			// Details
			me.$el.detailsContainer.on('change', 'input[name="description"]', me.updateMedia);
			me.$el.detailsContainer.on('submit', 'form', me.selectMedia);
			me.$el.detailsContainer.on('click', 'button', me.selectMedia);

			// URLzone
			me.$el.urlZone.find('form').submit( me.dropUrl );

			// Fileupload
			me.initFileupload();

			if(me.settings.onInit instanceof Function) me.settings.onInit.call(me);
		}

		/**
		 *	Abort al pending requests
		 *
		 *	@return void
		 */
		this.abortRequests = function()
		{
			for(var i in me.requests)
			{
				me.requests[i].abort();
			}
		}

		/**
		 *	Initialize the file upload progress
		 *
		 *	@return void
		 */
		this.initFileupload = function()
		{
			var $inputFile = me.$el.dropZone.find('input[type="file"]');

			$inputFile.fileupload({
			    url: '/api/mediabrowser/media',
			    dataType: 'json',
			    dropZone: me.$el.dropZone,
			    autoUpload: true,
			    acceptFileTypes: /(\.|\/)(gif|jpe?g|png|mp4)$/i,
			    maxFileSize: 5000000, // 5 MB
				messages: {
	                maxNumberOfFiles: 'Maximum aantal bestanden bereikt',
	                acceptFileTypes: 'Bestandstype niet toegestaan',
	                maxFileSize: 'Bestand is te groot',
	                minFileSize: 'Bestand is te klein'
	            },
	            formData: {}
			})
			.on('fileuploadprocessalways', function(e, data)
			{
				$.each(data.files, function (index, file)
			    {
			    	if(file.error)
			    	{
			    		alert( file.error );
			    	}
			    });
			})
			.on('fileuploadprogressall', function (e, data) 
			{
				var progress = parseInt(data.loaded / data.total * 100, 10);
				me.$el.dropZone.find('.progress').css('width', progress + '%');
			})
			.on('fileuploaddone', function (e, data) 
			{
				if(data.result.file)
				{
				    $.tmpl(me.settings.tmpl.mediaRow, data.result.file).prependTo( me.$el.mediaContainer );

				    me.$el.mediaContainer.find('li.nomedia').remove();
				}
				me.$el.dropZone.find('.progress').css('width', '0');
			})
			.on('fileuploadfail', function (e, data) 
			{
				me.$el.dropZone.find('.progress').css('width', '0');
			})
			.prop('disabled', !$.support.fileInput)
			    .parent().addClass($.support.fileInput ? undefined : 'disabled');

			// Add class when file is dragged over
			$(document).unbind('dragover');
			$(document).bind('dragover', function (e) 
			{
			    var dropZone = me.$el.dropZone,
			        timeout = window.dropZoneTimeout;
			    if (!timeout) {
			        dropZone.addClass('in');
			    } else {
			        clearTimeout(timeout);
			    }
			    var found = false,
			      	node = e.target;
			    do {
			        if (node === dropZone[0]) {
			       		found = true;
			       		break;
			       	}
			       	node = node.parentNode;
			    } while (node != null);
			    if (found) {
			        dropZone.addClass('hover');
			    } else {
			        dropZone.removeClass('hover');
			    }
			    window.dropZoneTimeout = setTimeout(function () {
			        window.dropZoneTimeout = null;
			        dropZone.removeClass('in hover');
			    }, 100);
			});
		}

		/**
		 *	Drop an url (vimeo, youtube, etc)
		 *
		 *	@param  Event object
		 *	@return void
		 */
		this.dropUrl = function(e)
		{
			e.preventDefault();

			var url = $(this).find('[name="url"]').val();

			$.ajax({
				type: 'POST',
				url: '/api/mediabrowser/media',
				dataType: 'json',
				data: $(this).serialize(),
				success: function( result )
				{
					$.tmpl(me.settings.tmpl.mediaRow, result.file).prependTo( me.$el.mediaContainer );
				}
			});
		}

		/**
		 * Filter the media based on the form
		 *
		 * @param  Event object
		 * @return void
		 */
		this.filterByForm = function(e)
		{
			me.loadMedia(e);
		}

		/**
		 * Filter the media based on the media type
		 *
		 * @param  Event object
		 * @return void
		 */
		this.filterByType = function(e)
		{
			if($(this).attr('data-mediable-type'))
				me.settings.mediableType = $(this).data('mediableType');
			else
				me.settings.mediableType = '';

			if($(this).attr('data-mediable-id'))
				me.settings.mediableId = $(this).data('mediableId');
			else
				me.settings.mediableId = '';

			if($(this).attr('data-tag'))
				me.settings.tags = [$(this).data('tag')];
			else
				me.settings.tags = [];

			$(this).closest('li').addClass('active').siblings('.active').removeClass('active');

			me.loadMedia(e);
		}

		/**
		 * The load more button loads the next page of media
		 *
		 * @param  Event object
		 * @return void
		 */
		this.loadMore = function(e)
		{
			me.settings.page++;

			me.loadMedia(e, true);
		}

		/**
		 *	Load all media that is attached to the current tag selection
		 *
		 *	@param  Event object
		 *	@param  bool|null append
		 *	@return void
		 */
		this.loadMedia = function(e, append)
		{
			e.preventDefault();
			me.abortRequests();

			if( ! append )
			{
				this.settings.page = 1;
			}

			me.$el.mediaContainer.parent().addClass('loading');
			me.requests.push($.getJSON(me.getMediaUrl(), me.getMediaParams(), function(media)
			{
				if( ! append )
					me.$el.loadMore.show();

				me.onMediaReceive(media, append);
			}));
		}

		/**
		 * Get the media URL to fetch media
		 * 
		 * @return string
		 */
		this.getMediaUrl = function()
		{
			return me.settings.url;
		}

		/**
		 * Get the parameters to send with the media fetch request
		 *
		 * @return array
		 */
		this.getMediaParams = function()
		{
			return $.extend({
				hide: this.settings.values,
				media_type: this.settings.mediaType,
				mediable_type: this.settings.mediableType,
				mediable_id: this.settings.mediableId,
				tags: this.settings.tags,
				page: me.settings.page,
				per_page: me.settings.perPage,
			},
			me.$el.filterForm.serializeObject());
		}

		/**
		 * Define the media url for an element and append the page variables
		 *
		 * @param  jquery element $el
		 * @return string
		 */
		this.getMediaUrlByElement = function( $el )
		{
			var url = $el.attr('href');

			var page = $(this).data('page');
			if( ! page) page = 1;
			page++;
			$(this).data('page', page);

			var perPage = $(this).data('perPage');
			if( ! perPage) perPage = 15;

			return url += (url.indexOf('?') >= 0 ? '&' : '?') + 'take=' + perPage + '&skip=' + (page * perPage - perPage);
		}

		/**
		 *	Handle a receival of media items via the api
		 *
		 *	@param  array media
		 *	@param  bool|null append
		 *	@return void
		 */
		this.onMediaReceive = function( media, append )
		{
			me.$el.mediaContainer.parent().removeClass('loading');

			if( ! append )
				me.$el.mediaContainer.empty();

			if(media.length)
				$.tmpl(me.settings.tmpl.mediaRow, media).appendTo( me.$el.mediaContainer );
			else
			{
				if( ! append )
					$.tmpl(me.settings.tmpl.noMedia).appendTo( me.$el.mediaContainer );

				me.$el.loadMore.hide();
			}

			if(me.settings.onMediaReceive instanceof Function) me.settings.onMediaReceive.call(me, media);
		}

		/**
		 *	User wants to view an image in the details section
		 *
		 *	@param  Event object
		 *	@return void
		 */
		this.previewMedia = function(e)
		{
			e.preventDefault();
			me.abortRequests();

			var $li = $(this).closest('li').addClass('active');
			if(!me.settings.multiple)
				$li.siblings('.active').removeClass('active');

			if(typeof $li.data('item') == 'undefined')
			{
				me.$el.detailsContainer.addClass('loading').find('form').hide();

				$.ajax({
					type: 'GET',
					url: '/api/media/' + $(this).data('id'),
					dataType: 'json',
					success: function( item )
					{
						$li.data('item', item);
						me.renderPreview( item, $li );
					}
				});
			}
			else
				me.renderPreview( $li.data('item'), $li );
		}

		/**
		 * Render the preview
		 *
		 * @param object item
		 * @param object $li current <li>
		 * @return void
		 */
		this.renderPreview = function( item, $li )
		{
			me.$el.detailsContainer.find('.preview').html( item.output );
			me.$el.detailsContainer.find('.resolution').text( item.resolution );
			me.$el.detailsContainer.find('input[name="description"]').val( item.description );

			me.$el.detailsContainer.data('current', $li);

			me.$el.detailsContainer.removeClass('loading').find('form').show();
		}

		/**
		 *	Un-preview image
		 *
		 *	@param  Event object
		 *	@return void
		 */
		this.unpreviewMedia = function(e)
		{
			e.preventDefault();
			me.abortRequests();

			var $li = $(this).closest('li').addClass('active');

			$li.removeClass('active');

			if(me.$el.detailsContainer.data('current')[0] == $li[0])
			{
				me.$el.detailsContainer.find('form').hide();
				me.$el.detailsContainer.data('current', '');
			}
		}

		/**
		 *	Event that is triggered when the media description changes
		 *
		 *	@param  Event object
		 *	@return void
		 */
		this.updateMedia = function(e)
		{
			me.abortRequests();

			var $li = me.$el.detailsContainer.data('current');

			var item = $li.data('item');

			item.description = $(this).val();
			item.output = $(item.output).attr('alt', $(this).val()).wrap('<div />').parent().html();
			item.preview = $(item.preview).attr('alt', $(this).val()).wrap('<div />').parent().html()

			$li.data('item', item);
		}

		/**
		 * The user pressed the select button. Trigger a submit event with the current selected image as data
		 *
		 * @param  Event object
		 * @return	void
		 */
		this.selectMedia = function(e)
		{
			e.preventDefault();
			me.abortRequests();

			var items = new Array();
			me.$el.mediaContainer.find('li.active').each(function()
			{
				items.push( $(this).data('item') );
			});

			me.$el.trigger('submit-media', {
				items: items
			});

			$.fancybox.close();
		}

		/**
		 * Remove the media from the storage
		 *
		 * @param  Event object
		 * @return	void
		 */
		this.removeMedia = function(e)
		{
			e.preventDefault();
			e.stopPropagation();

			if(confirm('Weet u het zeker? Deze actie kan niet worden teruggedraaid'))
			{
				var $item = $(this).closest('li');
				var itemId = $(this).siblings('[data-id!=""]').data('id');

				if(typeof itemId != 'undefined')
				{
					$.ajax({
						type: 'POST',
						dataType: 'json',
						url: '/api/media/' + itemId,
						data: {
							'_method': 'DELETE'
						},
						success: function()
						{
							$item.remove();
						}
					});
				}
			}
		}
	}
	
	$.fn.mediabrowser = function( options ) 
	{
		return this.each(function() 
		{
			var element = $(this);
			var newmediabrowser = new mediaBrowser();
			newmediabrowser.init.call(this, options);
		});
	};

	var mediaSelector = function() {
		
		var me = this;
		var el, $el;
		
		this.settings = {
			kind: '',
			previewClass: 'mediabrowser-preview form-control',
			mediabrowserUrl: '/api/mediabrowser',
			mediaType: 'all',
			multiple: false,
			view: 'simple',
			fancybox: {
				width: '95%',
				height: '95%',
				autoSize: false,
				padding: 0,
				wrapCSS: 'fancybox-mediabrowser'
			},
			tmpl: {
				simple: 	'<li>\
								<input type="hidden" name="media[description][]" data-rel="media.description" value="${description}" />\
								<input type="hidden" name="media[id][]" data-rel="media.id" value="${id}" />\
								<input type="hidden" name="media[kind][]" data-rel="media.kind" value="${kind}" />\
								<input type="hidden" name="media[active][]" data-rel="media.active" value="${active}" />\
								<a href="#" data-id="${id}" data-rel="mediaviewer">{{html preview}}</a>\
								<a href="#" class="remove" title="Verwijder afbeelding">\
								<span class="fa fa-trash-o"></span></a>\
							</li>',
				advanced: 	'<li class="clearfix">\
								<input type="hidden" name="media[id][]" data-rel="media.id" value="${id}" />\
								<input type="hidden" name="media[kind][]" data-rel="media.kind" value="${kind}" />\
								<input type="hidden" name="media[active][]" data-rel="media.active" value="${active}" />\
								<div class="preview">\
									{{html preview}}\
								</div>\
								<div class="fields clearfix">\
									<textarea name="media[description][]" data-rel="media.description" class="form-control">${description}</textarea>\
								</div>\
								<span class="actions"><a href="#" class="remove"><i class="fa fa-trash-o"></i></a></span>\
							</li>',
				newItem: 	'<li class="new">\
								<a href="#" title="Voeg nieuwe media toe"><span class="fa fa-plus"></span></a>\
							</li>'
			}
		}
		
		this.init = function( options ) 
		{
			$.extend(true, me.settings, options, $(this).data());

			me.el = this;
			me.$el = $(this);
			me.values = [];
			
			me.initPreview();

			if(typeof $(this).data('value') != 'undefined')
				me.setValues( $(this).data('value') );
		}

		/**
		 *	Init the media preview window
		 *
		 *	@return void
		 */
		this.initPreview = function()
		{
			me.$el.previewContainer = $('<ul class="' + me.settings.previewClass + ' ' + me.settings.view + '" />').appendTo(me.$el);

			me.$el.previewContainer.on('click', '.new a', function(e) 
			{
				e.preventDefault();

				var ids = [];
				for(var i in me.values)
				{
					ids.push( me.values[i].id );
				}

				$.fancybox($.extend(true, 
				{
					type: 'ajax',
					href: me.settings.mediabrowserUrl + '?mediaType=' + me.settings.mediaType + '&multiple=' + me.settings.multiple + '&values=' + encodeURIComponent(ids),
					helpers: {
						overlay: {
							locked: false
						}
					},
					afterShow: function()
					{
						$(this.inner).find('.mediabrowser').on('submit-media', function(e, data)
						{
							if(!me.settings.multiple)
								me.$el.previewContainer.children('*:not(.new)').remove();

							for(var i in data.items)
							{
								me.setValue( data.items[i] );
							}
						});
					}
				}, me.settings.fancybox));
			});

			me.$el.previewContainer.on('click', 'a.remove', function(e)
			{
				e.preventDefault();
				$(this).addClass('loading');

				if(confirm('Weet u het zeker?'))
				{
					me.removeValue( $(this).closest('li') );

					$(this).removeClass('loading');
				}
			});

			me.$el.previewContainer.on('click', '[data-toggle="set-active"]', function(e)
			{
				e.preventDefault();
				var $el = $(this).addClass('loading');

				$.ajax({
					dataType: 'json',
					type: 'POST',
					url: $el.attr('href'),
					data: $el.data(),
					success: function()
					{
						$el.removeClass('loading').hide().siblings('.active, .inactive').show();
					},
					error: function()
					{
						$el.removeClass('loading');
					}
				});
			});

			$.tmpl(me.settings.tmpl.newItem).appendTo(me.$el.previewContainer);

			// Make it sortable
			if(me.settings.multiple)
				me.initSortable();
		}

		/**
		 *	Init the sortable plugin
		 *
		 *	@return void
		 */
		this.initSortable = function()
		{
			me.$el.previewContainer.sortable();
		}

		/**
		 *	Set an array with values
		 *
		 *	@param  array|object values
		 *	@return void
		 */
		this.setValues = function( values )
		{
			if( Object.prototype.toString.call( values ) !== '[object Array]' )
			{
				values = [ values ];
			}

			for(var i in values)
			{
				me.setValue( values[i] );
			}
		}

		/**
		 *	Set a single value
		 *
		 *	@param  object value
		 *	@return void
		 */
		this.setValue = function( value )
		{
			var tmplData = $.extend(value, {
				counter: me.getMediaCounter()
			});
			if((tmplData.kind == '' || typeof tmplData.kind == 'undefined') && me.settings.kind != '') tmplData.kind = me.settings.kind;

			me.values.push(value);

			$newBtn = me.$el.previewContainer.children('.new');
			if(!me.settings.multiple) $newBtn.hide();

			var setValueParams = {
				view: me.settings.view,
				preview: $.tmpl(me.settings.tmpl[me.settings.view], tmplData).insertBefore( $newBtn )
			}

			if(me.settings.onSetValue instanceof Function)
				me.settings.onSetValue.call(me, setValueParams);
		}

		/**
		 *	Remove an item
		 *
		 */
		this.removeValue = function( $li )
		{
			$input = $li.find('[data-rel="media.id"]');

			var id = $input.val();
			for(var i in me.values)
			{
				if(me.values[i].id == id)
				{
					me.values.splice(i, 1);
				}
			}

			$li.remove();

			$newBtn = me.$el.previewContainer.children('.new');
			$newBtn.show();
		}

		/**
		 * Get the current media item counter
		 *
		 * @return int
		 */
		this.getMediaCounter = function()
		{
			var counter = 0;

			for(var i in mediaSelectors)
			{
				counter += mediaSelectors[i].values.length;
			}

			return counter;
		}
	}

	$.fn.mediaselector = function( options )
	{
		return this.each(function() 
		{
			var newmediaselector = new mediaSelector();
			mediaSelectors.push(newmediaselector);

			newmediaselector.init.call(this, options);
			$(this).data('mediaSelector', newmediaselector);
		});
	}

})( jQuery );